import React, { useRef, useMemo, memo } from 'react';
import { SponsoredProductItemWithClickEvent } from './sponsored-product-item';
import { useInVisualViewport, useSponsoredProductEvents } from 'common/hooks';
import { SponsoredProductItemProps } from 'types/sponsored-products';
import { calculateDiscount, getProductBelongFromSource, labelsGaNames } from './utils';

export const SponsoredListItemProduct = memo((props: SponsoredProductItemProps & { contentId: string }) => {
  const {
    contentId,
    productId,
    displayedName,
    productPriceCategory,
    price: { mainPrice, previousPrice, additionalPrice, previousAdditionalPrice, additionalAsMain },
    searchQuery,
    productPosition,
    source,
    // isInViewport,
  } = props;

  const productRef = useRef<HTMLDivElement | null>(null);

  const { isInViewport } = useInVisualViewport({
    elementRef: productRef,
    threshold: 0.8,
  });

  const displayedPreviousPrice = additionalAsMain ? previousAdditionalPrice : previousPrice;
  const displayedMainPrice = additionalAsMain ? additionalPrice : mainPrice;
  const productPrevPrice = displayedPreviousPrice ? displayedPreviousPrice.toFixed(2) : '';
  const productPrice = displayedMainPrice ? displayedMainPrice.toFixed(2) : '';
  const productDiscount = calculateDiscount(previousPrice, mainPrice);

  const gaTag = useMemo(() => {
    if (productPriceCategory === 'STD' && !productPrevPrice) return '';
    if (productPriceCategory && productPriceCategory !== 'STD' && productPrice < productPrevPrice)
      return `${labelsGaNames[productPriceCategory]}, discount`;
    return productPriceCategory ? labelsGaNames[productPriceCategory] : '';
  }, [productPriceCategory, productPrevPrice, productPrice]);

  const productBelong = useMemo(() => {
    return getProductBelongFromSource(source);
  }, [source]);

  const { handleClickEvent } = useSponsoredProductEvents({
    productRef,
    contentId,
    searchQuery: searchQuery,
    productId: Number(productId),
    productName: displayedName,
    productPosition: productPosition,
    productPrevPrice: Number(productPrevPrice) || null,
    productDiscount: productDiscount,
    productPrice: Number(productPrice) || null,
    productTag: gaTag || null,
    productBelong: productBelong,
    isInViewport,
  });

  return (
    <SponsoredProductItemWithClickEvent
      ref={productRef}
      onPointerUpWithoutScroll={handleClickEvent}
      key={productId}
      {...props}
      searchQuery={searchQuery}
    />
  );
});
